import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { AnyAction } from "redux";
import { Link } from "react-router-dom";
import { Table } from "antd";
import { all_routes } from "../../../router/all_routes";
import { getDnarList } from "../../../../core/data/redux/masterDnrSlice";

type AppDispatch = ThunkDispatch<any, any, AnyAction>;

export interface DnarList {
    id: number;
    dnar_id?: string;
    dnar_title?: string;
    sapCreatedAt?: string;
    sapModifiedAt?: string;
}





const DnrList = () => {

    const dispatch = useDispatch<AppDispatch>();
    const masterDnrState = useSelector((state: any) => state.masterDnrState);
    const [dataList, setDataList] = useState<DnarList[]>([]);
    const routes = all_routes;
    const columns = [
        {
            title: "Sr. No.",
            dataIndex: "id",
            key: "srNo",
            render: (_text: any, _record: any, index: number) => index + 1
        },
        {
            title: "dnar ID",
            dataIndex: "dnar_id",
            key: "dnar_id",
        },
        {
            title: "Dnar Title",
            dataIndex: "dnar_title",
            key: "dnar_title",
        }
    ];

    React.useEffect(() => {
        dispatch(getDnarList({}));
    }, []);

    React.useEffect(() => {
        setDataList(masterDnrState?.data?.data || [])
    }, [masterDnrState.loading]);

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <h3 className="page-title mb-1">DNAR List</h3>
                    <nav>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <Link to={routes.adminDashboard}>Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item active">DNAR List</li>
                        </ol>
                    </nav>
                </div>

                <div className="card">
                    <div className="card-body">
                        <Table
                            columns={columns}
                            dataSource={dataList}
                            loading={(masterDnrState && masterDnrState.isLoading) || false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DnrList;
